import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BotRegistrationService } from 'src/app/services/core/bot-registration/bot-registration.service';
import { ProactiveBotNotificationService } from 'src/app/services/core/bot-proactive-notification/bot-proactive-notification.service';
import { ConfigurationSettings } from 'src/app/models/configuration.settings';
import { ToasterService } from '../../../services/shared/toaster/toaster.service';
import { INotifyRequest } from 'src/app/models/notify-response';
import { UtilityService } from 'src/app/services/shared/utility/utility.service';

@Component({
  selector: 'app-botpushnotification',
  templateUrl: './botpushnotification.component.html',
  styleUrls: ['./botpushnotification.component.scss']
})
export class BotPushNotificationComponent implements OnInit {

  constructor(private httpClient: HttpClient,
    private botRegistrationService: BotRegistrationService,
    private configurationSetting: ConfigurationSettings,
    private toasterService: ToasterService,
    private proactiveBotNotificationService: ProactiveBotNotificationService,
    private utilityService: UtilityService
  ) { }

  userRoles: string[] = [];
  botList: any;
  showSubmitBtn: boolean;
  showTestBtn: boolean;
  messageKey: string;
  superAdmin:  boolean;
  botConfigId: number;
  notifyRequest: INotifyRequest

  ngOnInit() {

    this.userRoles = sessionStorage.getItem('userRoles') ? sessionStorage.getItem('userRoles').split(',') : [];
    let superAdminUser = this.userRoles.find(ob => ob.toLowerCase() === 'superadmin' || ob.toLowerCase() === 'super admin');
    if (superAdminUser) {
      this.superAdmin = true;
    }

    //Taking accessed bot list
this.botRegistrationService.getRegisteredBots()
      .subscribe(
        res => {
          sessionStorage.setItem("lastActiveTab", "utility");
          this.botList=this.setBotList(res);
          if (this.botList.length > 0) {
            this.botConfigId = this.botList[0].botConfigId;
            this.showTestBtn = true;
          }
        },
        (error) => {
          this.toasterService.error("Unable to fetch BOT(s) details at the moment");
        }
      )
  };

  setBotList(botlistResult) {
    let listOfBots = [];
    if (this.superAdmin) {
      botlistResult.forEach((item) => {
        listOfBots.push({ botConfigId: item.botConfigId, displayName: item.displayName });
      });
    }
    else {

      let botIds = this.utilityService.GetFeaturewiseBotList(sessionStorage.getItem('userBotRoles'),"ProactiveNotification");

      botlistResult.forEach((item) => {
        botIds.forEach((botConfigId) => {
          if (botConfigId == item.botConfigId) {
            listOfBots.push({ botConfigId: item.botConfigId, displayName: item.displayName })
          }
        });
      });
    }
    return listOfBots;
  }

  onBotChange(botConfigId) {
    this.showSubmitBtn=false;
    this.showTestBtn = true;
    this.messageKey = '';
    this.botConfigId = botConfigId;
  };

  initiatePushNotification() {
    if (this.isEmptyOrSpaces(this.messageKey)) {
      this.toasterService.info("Please enter the message key");
      return;
    }

    if (this.botConfigId<1) {
      this.toasterService.info("Invalid Bot");
      return;
    }

    this.showSubmitBtn = false;

    this.notifyRequest = {
      botConfigId: this.botConfigId,
      key: this.messageKey,
      initiatorTest: false
    }

    this.proactiveBotNotificationService.initiateProactiveNotification(this.notifyRequest)
      .subscribe(
        res => {
          console.log(res);
          if (res == null) {
            this.toasterService.error('Request Failed');
            this.showSubmitBtn = true;
            return;
          }

          if (res.success) {
            this.toasterService.info(res.message);
            this.messageKey = '';
            this.showSubmitBtn = false;
          }
          else {
            this.toasterService.error(res.message);
            this.showSubmitBtn = true;
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  initiatorTestPushNotification() {
    if (this.isEmptyOrSpaces(this.messageKey)) {
      this.toasterService.info("Please enter the message key");
      return;
    }

    if (this.botConfigId < 1) {
      this.toasterService.info("Invalid Bot");
      return;
    }

    this.showTestBtn = false;

    this.notifyRequest = {
      botConfigId: this.botConfigId,
      key: this.messageKey,
      initiatorTest: true
    }

    this.proactiveBotNotificationService.initiateProactiveNotification(this.notifyRequest)
      .subscribe(
        res => {
          console.log(res);
          if (res == null) {
            this.toasterService.error('Request Failed');
            this.showTestBtn = true;
            return;
          }

          if (res.success) {
            this.toasterService.info(res.message);
            this.showTestBtn = false;
            setTimeout(() => this.showSubmitBtn = true, 3000);
          }
          else {
            this.toasterService.error(res.message);
            this.showTestBtn = true;
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  isEmptyOrSpaces(str) {
    return str === null || str==undefined || str.trim() === '';
  }; 
}
